import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = (isDragged: boolean, isDisabled?: boolean) =>
  ({
    frameContentCSS: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "128px",
      background: isDragged ? colors.blue100 : colors.gray50,
      border: `2px dashed ${isDragged ? colors.blue700 : colors.gray200}`,
      borderRadius: "8px",
      padding: "22px 30px",
      textAlign: "center",
      boxSizing: "border-box",
      cursor: isDisabled ? "auto" : "pointer",
      transition: "all 0.3s ease-in-out",

      "&:hover": {
        background: isDisabled ? colors.gray50 : colors.blue100,
        border: `2px dashed ${isDisabled ? colors.gray200 : colors.blue700}`
      },

      ".on-drag-enter-enter, .on-drag-leave-enter": {
        opacity: "0"
      },

      ".on-drag-enter-enter-active, .on-drag-leave-enter-active": {
        opacity: "1",
        transition: "opacity 300ms ease-in-out"
      },

      ".on-drag-enter-exit, .on-drag-leave-exit": {
        opacity: "1"
      },

      ".on-drag-enter-exit-active, .on-drag-leave-exit-active": {
        opacity: "0"
      }
    }
  }) as CSSObject;
